module.exports = __webpack_public_path__ + "img/stock0.a4be7ceb.png";